import type { ParsedUrlQuery } from "querystring";

import { PRICE_OPTIONS, PRICE_SEPARATOR_URL } from "constants/filterOptions";
import { decodeParams } from "./encodeDecodeURI";
import { Specialization } from "utils/interfaces/commonInterfacesAndTypes";

export const extractPriceFilterValues = (encodedPrice: string) => {
  const decodedPrice = decodeURI(encodedPrice);

  const isRange = decodedPrice.includes(PRICE_SEPARATOR_URL);

  const priceFilterValues = { priceFromValue: 0, priceToValue: 0 };

  if (isRange) {
    const [min, max] = decodedPrice.split(PRICE_SEPARATOR_URL);
    priceFilterValues.priceFromValue = parseInt(min, 10);
    priceFilterValues.priceToValue = parseInt(max, 10);
  } else {
    priceFilterValues.priceFromValue = parseInt(decodedPrice, 10);
  }

  // if (decodedPrice === PRICE_OPTIONS.LESS_THAN_100) {
  //    priceFilterValues.priceToValue = 100;
  // } else if (decodedPrice === PRICE_OPTIONS.BETWEEN_100_AND_250) {
  //    priceFilterValues.priceFromValue = 100;
  //    priceFilterValues.priceToValue = 250;
  // } else {
  //    priceFilterValues.priceFromValue = 250;
  // }

  return priceFilterValues;
};

export const extractSpecializationFilterValues = (
  encodedMassageMainCategories: string | string[],
  query: ParsedUrlQuery
) => {
  const specializations: Specialization[] = [];
  let serviceTypes: string[] = [];

  if (encodedMassageMainCategories instanceof Array) {
    encodedMassageMainCategories.forEach((category) => {
      if (query[category]) {
        serviceTypes = decodeParams(query[category] as string[]) as string[];
        specializations.push({
          specializationType: decodeURI(category),
          serviceTypes,
        });
      } else {
        specializations.push({
          specializationType: decodeURI(category),
        });
      }
    });
  } else if (query[encodedMassageMainCategories]) {
    serviceTypes = decodeParams(
      query[encodedMassageMainCategories] as string[]
    ) as string[];
    specializations.push({
      specializationType: decodeURI(encodedMassageMainCategories),
      serviceTypes,
    });
  } else {
    specializations.push({
      specializationType: decodeURI(encodedMassageMainCategories),
    });
  }

  return specializations;
};
